import { render, staticRenderFns } from "./reward_rule.vue?vue&type=template&id=18c63caa&"
import script from "./reward_rule.vue?vue&type=script&lang=js&"
export * from "./reward_rule.vue?vue&type=script&lang=js&"
import style0 from "./reward_rule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports